// The invite code remembered from an ?ref= link (see index.js), sent with signup.
export function inviteRef() {
  try { return localStorage.getItem('uf-ref') || undefined; } catch { return undefined; }
}
